import { addMinutes } from 'date-fns';
import { fromUTC } from 'src/utilities/fromUTC';

/**
 * Adds minutes to a UTC date string and returns a display-ready Date.
 *
 * Performs arithmetic in real UTC space (where DST doesn't exist),
 * then converts the result via fromUTC so that local-timezone
 * getters (getHours, format, etc.) show the correct wall-clock values.
 *
 * This avoids a DST bug where addMinutes on a fromUTC-shifted
 * Date can gain or lose an hour when crossing a DST boundary.
 */
export function addMinutesToUtcDate(
  utcDateString: string,
  minutes: number
): Date {
  const realUtcEnd = addMinutes(new Date(utcDateString), minutes);
  return fromUTC(realUtcEnd.toISOString());
}
